import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../styles";
import HTMLContent from "../../shared/HTMLContent";
import { PageReference } from "../../shared/PageReference";

const CompanyOverviewSection = ({ t, supplierData = {}, meta }) => {
    const supplierDetail = supplierData?.supplierDetail || {};

    return (
        <View style={styles.wordSectionContent}>
            <PageReference id={meta?.anchorId} />
            <Text style={styles.wordOverviewLabel}>{t("Company Overview")}:</Text>
            <View style={styles.wordOverviewBody}>
                {supplierDetail?.description ? (
                    <HTMLContent content={supplierDetail.description} />
                ) : (
                    <Text style={styles.emptyStateText}>{t("No Data")}</Text>
                )}
            </View>
        </View>
    );
};

export default withNamespaces()(CompanyOverviewSection);
